import axios from 'axios';

const getApiBaseUrl = () => {
    // If REACT_APP_API_URL is set, use it (for custom deployments)
    if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;

    // Use relative path (empty string) to leverage proxy configuration
    // In development: proxy in package.json routes to http://localhost:5500
    // In production: nginx/web server should proxy /api to backend
    return '';
};

const API_BASE_URL = getApiBaseUrl();

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Request interceptor - add auth token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('vms_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor - handle auth errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Token expired or invalid — VMS is SSO-only, so send the user
            // back to the QuirkyQode portal rather than a local login page.
            localStorage.removeItem('vms_token');
            localStorage.removeItem('vms_user');
            window.location.href = process.env.REACT_APP_QQ_PORTAL_URL || 'https://quirkyqode.com/my-tools';
        }
        return Promise.reject(error);
    }
);

// Pulls a human-readable message out of an API error — handles express-validator's
// { errors: [{ msg }] } shape, a plain { message }, a plain string body, or falls
// back to axios's generic "Request failed with status code NNN".
export const extractErrorMessage = (error, fallback = 'Something went wrong. Please try again.') => {
    const data = error?.response?.data;
    if (data?.errors?.length) return data.errors.map(e => e.msg).filter(Boolean).join(', ');
    if (data?.message) return data.message;
    if (typeof data === 'string' && data.trim()) return data;
    return error?.message || fallback;
};

export default api;
